module.exports = __webpack_public_path__ + "static/media/carrito.69959036.svg";